<!--  -->
<template>
<div class='asidelayout'>
    <div id="itemcontainer" ref="itemcontainer" class="itemcontainer" :style="isMobile?asideStyle2:asideStyle">
        <div class="item" v-for="(item,i) in asides" :key="i" @click="item.link?$router.push(item.link):showIntroduce()">
            <div class="icon">
                <span class="itembg"><img :src="item.bg" alt=""></span>
                <span :class="['img',`img${i}`]"><img :src="item.img" alt=""></span>
            </div>
            <div class="name">{{item.name}}</div>
        
    </div>
    </div>
    <div v-if="!isMobile" class="arrow" @click="changeRight"><img src="@/assets/images/sidebar-button.png" alt=""></div>
    
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import browser from '@/utils/browser.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    isMobile:browser.mobile,
    introduce:false,
    asideStyle:{
        right:'-13.5vw',
        
    },
    asideStyle2:{
        bottom:0,
    },
    asides:[{
        bg:require(`@/assets/images/button-1.png`),
        img:require(`@/assets/images/button-1-1.png`),
        name:'场馆漫游',
        link:'/scenes'
    },{
        bg:require(`@/assets/images/button-2.png`),
        img:require(`@/assets/images/button-2-1.png`),
        name:'全景风貌',
        link:'/panorama'
    },{
        bg:require(`@/assets/images/button-3.png`),
        img:require(`@/assets/images/button-3-1.png`),
        name:'文物赏析',
        link:'/antiques'
    },{
        bg:require(`@/assets/images/button-4.png`),
        img:require(`@/assets/images/button-4-1.png`),
        name:'场馆介绍'
        
    },]
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    changeRight() {       
        if(this.asideStyle.right==0)
        {            
            this.asideStyle.right = '-13.5vw';
        }else this.asideStyle.right = 0;
        
    },
    showIntroduce() {
        this.$showIntroduce(this.introduce);
    }

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
    if(this.$route.name!=="首页") {
        this.$refs.itemcontainer.style.animation='none'
    }
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.asidelayout {
    .itemcontainer {
        position:fixed;
        z-index:9;
        top:0;
        right:-13.5vw;
        display:flex;
        width:100%;
        width:13.5vw;
        height:100%;
        background:url('../../assets/images/sidebar.png')center no-repeat;
        background-size:100% 100%;
        flex-direction: column;
        justify-content:center; 
        animation:start 1s 2s linear ;      
        transition: all 1s linear;
        .item {
            position:relative;
            margin-bottom:7.4vh;
            &:hover {
                .icon {
                    .itembg {
                        animation:rotate 3s  linear infinite;
                    }
                }
            }
            .icon {
                position:relative;
                width:5.36vw;
                height:5.36vw;
                margin:0 auto;
                .itembg {
                    display:block;
                    width:100%;
                    
                    
                }
                .img {
                    position:absolute;
                    display:block;
                    width:100%;
                    top:0;
                }    
            }
            .name {
                color:#fff;
                
            }
                
        
        }
    }
    .arrow {
        position:fixed;
        z-index:100;
        right:0;
        top:0;
        bottom:0;
        margin:auto;
        width:1vw;
        height:2vw;
    }
    
}
@keyframes rotate {
    from {
        transform:rotate(0deg)
    }
    to {
        transform:rotate(360deg)
    }
}
@keyframes rotatearrow {
    0% {
        transform:rotate(0deg)
    }
    50% {
        transform:rotate(180deg)
    }
    100% {
        transform:rotate(360deg)
    }
}
@keyframes rotateshow {
    from {
        transform:rotate(0deg)
    }
    to {
        transform:rotate(180deg)
    }
}
@keyframes rotatehide {
    from {
        transform:rotate(180deg)
    }
    to {
        transform:rotate(360deg)
    }
}
@keyframes start {
    // 0% {
    //     transform:translateX(0)
    // }
    // 40% {
    //     transform:translateX(-100%)
    // }
    // 60%{
    //     transform:translateX(-100%)
    // }
    // 100% {
    //     transform:translateX(0)
    // }
    0% {
        right:-13.5vw;
    }
    40% {
        right:0;
    }
    60% {
        right:0;
    }
    100% {
        right:-13.5vw;
    }
}
@media screen and (max-width:600px) {
    .asidelayout {
        .itemcontainer {
            position:fixed;
            z-index:20;
            bottom:0;
            left:0;
            right:auto;
            top:auto;
            display:flex;
            flex-direction: row;
            width:100%;
            height:26.67vw;
            background:url('../../assets/images/mobile/sidebar.png')center no-repeat;
            background-size:100% 100%;
            justify-content:center;
            animation:none ;
            transition: none;
            .item {
                position:relative;
                width:25%;
                margin-top:6.67vw;
                margin-bottom:0;
                &:hover {
                    .icon {
                        .itembg {
                            animation:rotate 3s  linear infinite;
                        }
                    }
                }
                .icon {
                    position:relative;
                    width:12vw;
                    height:12vw;
                    margin:0 auto;
                    .itembg {
                        display:block;
                        width:100%;
                        
                        
                    }
                    .img {
                        position:absolute;
                        display:block;
                        width:100%;
                        top:0;
                    }    
                }
                .name {
                    color:#fff;
                    
                }
                    
            
            }
        }
        .arrow {
            position:fixed;
            z-index:100;
            right:0;
            top:0;
            bottom:0;
            margin:auto;
            width:1vw;
            height:2vw;
        }
        
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layout/aside.vue